import React from 'react';
import PropTypes from 'prop-types';
import { Link, browserHistory } from 'react-router';
import { Button } from 'react-bootstrap';
import Notification from '../Notification/Notification';
import NotificationSomethingWrong from '../Notification/NotificationSomethingWrong';
import FormPasswordContainer from '../../redux/containers/FormPasswordContainer';
import PageHeader from '../PageHeader/PageHeader';
import loader from '../../assets/loading.gif';

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      verified: false,
      loading: false,
      success: false,
      error: false,
      tokenError: false
    };

    this.submitForm = this.submitForm.bind(this);
  }

  componentWillMount() {
    this.props.verifyToken(this.props.token).then(
      (response) => {
        const inUse = response.entity.pop().inUse;
        this.setState({ tokenError: !inUse, verified: true });
      },
      () => this.setState({ tokenError: true, verified: true })
    );
  }

  submitForm() {
    this.setState({ loading: true });
    this.props.submitResetPassword(this.props.password, this.props.token).then(
      () => {
        browserHistory.push('/login');
      },
      () => this.setState({
        loading: false,
        success: false,
        error: true
      })
    );
  }

  render() {
    if (!this.state.verified) {
      return null;
    }

    const validToken = (
      <div>
        <section className="section-half-margin">
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <p>Please enter your new password below.</p>
                {this.state.success &&
                  <Notification>
                    Done! We have send a message to {this.state.successEmail}
                  </Notification>
                }
                {this.state.error &&
                  <NotificationSomethingWrong />
                }
              </div>
            </div>
            <div className="row">
              <div className="col-sm-5">
                <FormPasswordContainer
                  name="password"
                  autotestClass="autotest-reset-password"
                  label="Password"
                  placeholder="Password"
                  maxLength={100}
                  required
                />
              </div>
              <div className="col-sm-5">
                <FormPasswordContainer
                  name="confirmPassword"
                  autotestClass="autotest-confirm-reset-password"
                  label="Confirm password"
                  placeholder="Confirm password"
                  maxLength={100}
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <small>
                  Your password needs to contain at least 8 characters, one upper case and one numeric character.
                </small>
              </div>
            </div>
          </div>
        </section>
        <section className="section-half-margin">
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <Button
                  id="submit-reset-password"
                  className="btn btn-default"
                  type="submit"
                  disabled={this.state.loading}
                >
                  {this.state.loading ?
                    <img
                      src={loader}
                      height="20"
                      alt="Loading..."
                      role="presentation"
                    /> : 'Reset Password'}
                </Button>
              </div>
            </div>
          </div>
        </section>
      </div>
    );

    const invalidToken = (
      <section className="section-half-margin">
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <Notification>
                It looks like you have already used this link or you didn&#39;t use it in time
                (it&#39;s valid for 2 hours).<br /><br />
                You&#39;ll need to go back and <Link to="/forgot-password">reset your password again</Link>.
              </Notification>
            </div>
          </div>
        </div>
      </section>
    );

    return (
      <main>
        <PageHeader title={'Reset Password'} />
        <form onSubmit={this.props.handleSubmit(this.submitForm)}>
          { this.state.tokenError ? invalidToken : validToken }
        </form>
      </main>
    );
  }
}

ResetPassword.propTypes = {
  verifyToken: PropTypes.func,
  submitResetPassword: PropTypes.func,
  token: PropTypes.string,
  handleSubmit: PropTypes.func,
  password: PropTypes.string
};

export default ResetPassword;



/** WEBPACK FOOTER **
 ** ./src/components/ResetPassword/ResetPassword.js
 **/